module.exports = __webpack_public_path__ + "img/Group2.89af0449.png";